import { CustomFieldsType } from '@danone-global/ct/interfaces'

export const customFieldValue = <T>(
  { custom }: { custom?: CustomFieldsType },
  name: string,
) =>
  custom?.customFieldsRaw.find((f) => f.name === name)?.value as T | undefined
